import $ from 'jquery';
import {trapFocus, removeTrapFocus} from '@shopify/theme-a11y';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

const namespace = 'modal';

export default class Modal {
  constructor(options) {
    this.options = $.extend(
      true,
      {
        classes: {
          active: 'is-active',
        },
        data: {
          source: 'data-modal-body',
          title: 'data-modal-title',
        },
        selectors: {
          modal: '#modal',
          insertElement: '.modal__body',
          title: '.modal__title',
          close: '.modal__close',
          triggers: '[data-modal-body]',
          responseTarget: '[data-page-content]',
          responseTableTarget: '[data-page-table]'
        },
      },
      options,
    );

    this.$modal = $(this.options.selectors.modal);
    this.modal = this.$modal.get(0);
    this.$modalTitle = $(this.options.selectors.title, this.$modal);
    this.$close = $(this.options.selectors.close, this.$modal);
    this.$triggers = $(this.options.selectors.triggers);

    this.bind();
  }

  bind() {
    $(document).on(
      `click.${namespace}`,
      this.options.selectors.triggers,
      this.handleClick.bind(this),
    );

    $(document).on(
      `click.close.${namespace}`,
      this.handleDocumentClick.bind(this),
    );
  }

    /**
   * @param {Event} event
   */
  handleDocumentClick(event) {
    const $target = $(event.target);
    const isChild = (this.$modal.has($target).length >= 1);
    const hasClose = (this.$close.has($target).length >= 1);
    const isClose = this.$close.is($target);
    const isTrigger = this.$triggers.is($target);
    const hasTrigger = (this.$triggers.has($target).length >= 1);

    if (!this.isActive()) {
      return;
    }

    if (isTrigger || hasTrigger) {
      return;
    }

    if (!isChild || isClose || hasClose) {
      this.close();
    }
  }

  /**
   * Close the modal
   */
  close() {
    this.$modal.removeClass(this.options.classes.active);
    removeTrapFocus(this.modal);
    enableBodyScroll(this.modal);
  }

  /**
   * Open the modal
   */
  open() {
    this.$modal.addClass(this.options.classes.active);
    trapFocus(this.modal);
    disableBodyScroll(this.modal);
  }

  /**
   * @returns {Boolean}
   */
  isActive() {
    return this.$modal.hasClass(this.options.classes.active);
  }

  /**
   * @param {Event} event
   * @returns {Promise}
   */
  handleClick(event) {
    event.preventDefault();

    const {target} = event;
    const dataSrc = $(target).attr(this.options.data.source);
    const title = $(target).attr(this.options.data.title);

    return this.getData(dataSrc).then(this.render.bind(this, title));
  }

  /**
   * @param {String} url
   * @returns {Promise}
   */
  getData(url) {
    return $.ajax(url).then((html) => {
      const $targetHtml = $(this.options.selectors.responseTarget, html);

      if (!$targetHtml.length) {
        return;
      }

      const dataReturn = [
        $targetHtml
      ]

      // Adds table section if it exists (i.e., size-guide template)
      const $targetTableHtml = $(this.options.selectors.responseTableTarget, html);
      if ($targetTableHtml) {
        dataReturn.push($targetTableHtml)
      }

      return dataReturn;
    });
  }

  /**
   * @param {String} title
   * @param {String} data
   */
  render(title = '', data) {
    const $destination = $(this.options.selectors.insertElement, this.$modal);

    $destination.html(data);
    this.$modalTitle.html(title);

    this.open();
  }
}
